export default "__VITE_ASSET__CqXm_GI6__"